import { render, staticRenderFns } from "./ArchivedList.vue?vue&type=template&id=54b79d2e&scoped=true"
import script from "./ArchivedList.vue?vue&type=script&lang=js"
export * from "./ArchivedList.vue?vue&type=script&lang=js"
import style0 from "./ArchivedList.vue?vue&type=style&index=0&id=54b79d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b79d2e",
  null
  
)

export default component.exports